const TRUTHY_STRINGS = new Set(['true', '1', 'yes', 'on', 'enabled']);
const FALSY_STRINGS = new Set(['false', '0', 'no', 'off', 'disabled', '']);

/**
 * Normalize loosely formatted environment flag values into a boolean.
 * Accepts common truthy variants we use in deployment configs ("1", "enabled", "on", etc.).
 */
export function isTruthyEnvFlag(value: unknown): boolean {
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'number') {
    return Number.isFinite(value) && value !== 0;
  }
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (TRUTHY_STRINGS.has(normalized)) {
      return true;
    }
    if (FALSY_STRINGS.has(normalized)) {
      return false;
    }
  }
  return false;
}

/**
 * Normalize an environment flag to the string values we surface in diagnostics.
 */
export function normalizeEnvFlag(value: unknown): string | null {
  if (value === null || value === undefined) {
    return null;
  }
  if (isTruthyEnvFlag(value)) {
    return 'true';
  }
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (FALSY_STRINGS.has(normalized)) {
      return 'false';
    }
  }
  if (value === false || value === 0) {
    return 'false';
  }
  return null;
}
